function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaintenance = function SvgMaintenance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-10",
    d: "M89.05,437.1c87.26,46,228.74,46,316,0s87.26-120.62,0-166.63-228.74-46-316,0S1.78,391.09,89.05,437.1Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "163.51 357.3 166.13 354.18 86.76 308.35 81.38 311.45 109.57 327.73 82.5 343.36 54.07 326.94 48.7 330.05 129.94 376.95 130.79 375.93 131.22 376.17 162.38 358.22 162.63 358.36 163.08 357.81 163.75 357.43 163.51 357.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10",
    cx: 357.41,
    cy: 381.96,
    rx: 44.22,
    ry: 21.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10",
    cx: 223.83,
    cy: 425.39,
    rx: 44.22,
    ry: 21.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10",
    d: "M392.67,408.28c8.58,5,22.49,5,31.07,0s8.58-13,0-17.94-22.49-4.95-31.07,0S384.09,403.33,392.67,408.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10",
    cx: 89.84,
    cy: 404.57,
    rx: 21.97,
    ry: 12.68,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131,189.48,86.48,310.75v0a1.59,1.59,0,0,1-.78.84,4.47,4.47,0,0,1-4.06,0,1.53,1.53,0,0,1-.83-1,.91.91,0,0,1,0-.33,2.77,2.77,0,0,1,.16-.83L125.64,187.5a2.88,2.88,0,1,1,5.4,2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.48,
    y1: 272.92,
    x2: 116.16,
    y2: 298.72,
    style: {
      fill: "none",
      stroke: "#37474f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.97,
    y1: 254.16,
    x2: 148.66,
    y2: 279.96,
    style: {
      fill: "none",
      stroke: "#37474f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.68,181.15l23.83-13.76a6.29,6.29,0,0,1,9.63,4.28L167.7,356.75a1.65,1.65,0,0,1,.05.38,1.79,1.79,0,0,1,0,.4,1.54,1.54,0,0,1-.83,1,4.47,4.47,0,0,1-4.06,0,1.72,1.72,0,0,1-.79-.86,1.36,1.36,0,0,1,0-.17L122.52,172.87a1.05,1.05,0,0,0-.37-.7,1,1,0,0,0-.76.2L97.55,186.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,358l-14.51-8.38a1.91,1.91,0,0,1-.87-1.5v-.34a1.89,1.89,0,0,1,.87-1.5l34.82-20.11a1.91,1.91,0,0,1,1.74,0l14.51,8.38a1.92,1.92,0,0,1,.87,1.5v.35a1.92,1.92,0,0,1-.87,1.5L135.31,358A1.91,1.91,0,0,1,133.57,358Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,346.94a1.75,1.75,0,0,0-.26.86v.34a1.91,1.91,0,0,0,.87,1.5L133.57,358a1.78,1.78,0,0,0,.87.21v-2.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,356.18v2.05a1.78,1.78,0,0,0,.87-.21l17.41-10,17.41-10.05a1.92,1.92,0,0,0,.87-1.5v-.35a1.72,1.72,0,0,0-.26-.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,328.59l-14.52-8.38a1.94,1.94,0,0,1-.86-1.5v-.35a1.94,1.94,0,0,1,.86-1.5l34.83-20.1a1.89,1.89,0,0,1,1.73,0l14.52,8.38a1.91,1.91,0,0,1,.86,1.5V307a1.88,1.88,0,0,1-.86,1.5L129,328.59A1.89,1.89,0,0,1,127.28,328.59Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,317.51a1.73,1.73,0,0,0-.25.85v.35a1.94,1.94,0,0,0,.86,1.5l14.52,8.38a1.75,1.75,0,0,0,.87.21v-2.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,326.75v2.05a1.74,1.74,0,0,0,.86-.21l17.42-10,17.41-10.06a1.88,1.88,0,0,0,.86-1.5v-.34a1.7,1.7,0,0,0-.25-.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,299.16l-14.52-8.38a1.92,1.92,0,0,1-.87-1.5v-.35a1.92,1.92,0,0,1,.87-1.5l34.83-20.1a1.89,1.89,0,0,1,1.73,0l14.51,8.38a1.91,1.91,0,0,1,.87,1.5v.34a1.89,1.89,0,0,1-.87,1.5l-34.82,20.11A1.89,1.89,0,0,1,121,299.16Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,288.08a1.75,1.75,0,0,0-.26.85v.35a1.92,1.92,0,0,0,.87,1.5l7.26,4.19,7.26,4.19a1.71,1.71,0,0,0,.86.21v-2.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.85,297.31v2.06a1.75,1.75,0,0,0,.87-.21l17.41-10.05,17.41-10.06a1.89,1.89,0,0,0,.87-1.5v-.34a1.88,1.88,0,0,0-.25-.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,269.73l-14.51-8.38a1.92,1.92,0,0,1-.87-1.5v-.35a1.92,1.92,0,0,1,.87-1.5L135,237.9a1.89,1.89,0,0,1,1.73,0l14.52,8.38a1.89,1.89,0,0,1,.87,1.5v.34a1.91,1.91,0,0,1-.87,1.5l-34.83,20.11A1.92,1.92,0,0,1,114.69,269.73Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56,267.88v2.06a1.74,1.74,0,0,0,.86-.21l17.42-10.05,17.41-10.06a1.91,1.91,0,0,0,.87-1.5v-.34a1.75,1.75,0,0,0-.26-.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56,258.65a1.84,1.84,0,0,0-.25.85v.35a1.92,1.92,0,0,0,.87,1.5l14.51,8.38a1.75,1.75,0,0,0,.87.21v-2.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,240.3,84.27,226.37a1.91,1.91,0,0,1-.86-1.5v-.34a1.92,1.92,0,0,1,.86-1.5l34.83-20.11a1.89,1.89,0,0,1,1.73,0L145,216.85a1.91,1.91,0,0,1,.86,1.5v.34a1.94,1.94,0,0,1-.86,1.5L110.13,240.3A2,2,0,0,1,108.4,240.3Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26,238.45v2.05a1.75,1.75,0,0,0,.87-.2l17.41-10.06L145,220.19a1.94,1.94,0,0,0,.86-1.5v-.35a1.73,1.73,0,0,0-.25-.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,223.67a1.88,1.88,0,0,0-.25.86v.34a1.91,1.91,0,0,0,.86,1.5L108.4,240.3a1.73,1.73,0,0,0,.86.2v-2.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,208.24,54,329.37v0l-.1.27a1.86,1.86,0,0,1-.72.7,4.55,4.55,0,0,1-4.07,0,1.58,1.58,0,0,1-.83-1,1.82,1.82,0,0,1,0-.33,2.73,2.73,0,0,1,.17-.84L93.15,206.26a2.88,2.88,0,1,1,5.4,2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,186.13a4.46,4.46,0,0,0-1.91,4.3L135.21,375.5a1.74,1.74,0,0,1,.06.45,1.71,1.71,0,0,1,0,.32,1.56,1.56,0,0,1-.83,1,4.47,4.47,0,0,1-4.06,0,1.77,1.77,0,0,1-.79-.83,0,0,0,0,0,0,0l-.05-.24L90,191.64a10.26,10.26,0,0,1,4.66-10.49",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.59,373.06l-36.7-.5-.32,30h0c0,2.72,1.74,5.45,5.3,7.56,7.12,4.21,18.74,4.34,25.95.28,3.64-2.05,5.46-4.77,5.46-7.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,365.13c-7.21,4.06-7.28,10.77-.16,15s18.74,4.34,26,.28,7.28-10.77.16-15S84.56,361.07,77.35,365.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,372.94a4.45,4.45,0,0,1-.26,1.43c-.56,1.72-2.06,3.32-4.4,4.64a25.1,25.1,0,0,1-12.22,2.75,24.92,24.92,0,0,1-12.14-3,8.93,8.93,0,0,1-4.25-4.63,4.53,4.53,0,0,1-.26-1.54c0-2.24,1.68-4.4,4.65-6.05a24.53,24.53,0,0,1,12.2-2.76,24.67,24.67,0,0,1,12.16,3C105.44,368.52,107,370.7,107,372.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76,374.37c-.56,1.72-2.06,3.32-4.4,4.64a25.1,25.1,0,0,1-12.22,2.75,24.92,24.92,0,0,1-12.14-3,8.93,8.93,0,0,1-4.25-4.63,8.77,8.77,0,0,1,4.39-4.62,24.75,24.75,0,0,1,12.2-2.77,24.89,24.89,0,0,1,12.16,3A9,9,0,0,1,106.76,374.37Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.07,384.29c.8-.46,1.45-.07,1.44.85A3.21,3.21,0,0,1,98,387.63c-.81.46-1.45.07-1.44-.85A3.19,3.19,0,0,1,98.07,384.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,377.83c-2,4-6,13.44-.82,17.29.22.16.42.3.64.44l0,1.92c-.52-.32-1.06-.68-1.58-1.06-7.79-5.77,1-20.59,1.38-21.21a.74.74,0,0,1,.44-.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,386.34c-.22.46-5.89,11.3-15.22,13.48a13.54,13.54,0,0,1-3.21.38,16.21,16.21,0,0,1-8.69-2.72l0-1.92c3.85,2.68,7.73,3.6,11.52,2.72,8.61-2,14.12-12.58,14.16-12.68a.8.8,0,0,1,1.08-.34A.78.78,0,0,1,98.75,386.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.93,281.05l-3.8-2.19a4.8,4.8,0,0,1-2.16-3.75V101.88a4.78,4.78,0,0,1,2.16-3.75L296.79,25.58a4.79,4.79,0,0,1,4.33,0l3.79,2.19a4.78,4.78,0,0,1,2.17,3.75V204.76a4.78,4.78,0,0,1-2.17,3.75L179.26,281.05A4.79,4.79,0,0,1,174.93,281.05Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,31.16c-.15-1.12-1.06-1.53-2.14-.9L179.25,102.81a4.52,4.52,0,0,0-1.53,1.62l-8.12-4.69a4.43,4.43,0,0,1,1.53-1.62L296.78,25.57a4.79,4.79,0,0,1,4.33,0l3.8,2.19A4.85,4.85,0,0,1,307.05,31.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,281.27a4.8,4.8,0,0,1-3.83-.22l-3.79-2.19a4.78,4.78,0,0,1-2.17-3.75V101.87a4.45,4.45,0,0,1,.64-2.13l8.12,4.69a4.43,4.43,0,0,0-.63,2.13V279.8C177.09,281,177.8,281.56,178.75,281.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.89,167.52h0a1,1,0,0,0-1,.1L310.79,171a1.46,1.46,0,0,1-2-.46,11.83,11.83,0,0,0-1-1.21,2.49,2.49,0,0,1-.59-2.4l8-5.1-6-3.46h0a1.68,1.68,0,0,0-.39-.16l-3.82-.85a2.08,2.08,0,0,0-2.16,1l-3.58,6.83a3.72,3.72,0,0,1-2.17,1.63l-.22.07a9.06,9.06,0,0,0,.32-1.59l-6-3.48h0A1,1,0,0,0,290,162l-5.71,4.49a3.2,3.2,0,0,0-1.09,2.42l.34,5.44a4.35,4.35,0,0,1-.89,2.63c-.93,1.12-1.82,2.29-2.65,3.51a3,3,0,0,1-2.32,1.18l-3.68-.18a2.38,2.38,0,0,0-2.11,1.29l-3.45,7.74a1.46,1.46,0,0,0,.59,1.86h0l4.07,2.35a1.79,1.79,0,0,1,.09,1.05,35.33,35.33,0,0,0-.63,3.7,4.71,4.71,0,0,1-1.24,2.51l-5.06,4.65a3.07,3.07,0,0,0-.85,2.49l.95,5.52a1,1,0,0,0,.46.75h0l6,3.48.08-6.91a1.46,1.46,0,0,1,2,.46,10.56,10.56,0,0,0,1,1.21,2.52,2.52,0,0,1,.6,2.4L274,223a1.26,1.26,0,0,0,.5,1.55h0l6,3.48,1.64-4.5,2.33-5.78a3.7,3.7,0,0,1,2.16-1.63,19.58,19.58,0,0,0,2.35-.78,1.3,1.3,0,0,1,1.8.83l1.29,4.27a1.14,1.14,0,0,0,.49.67h0l6.05,3.48-1.06-6.68,1.85-1.46a3.17,3.17,0,0,0,1.08-2.42l-.34-5.44a4.32,4.32,0,0,1,.89-2.63c.94-1.12,2.35-1.72,3.18-2.93.47-.69,1-1.8,1.8-1.76l3.67.18a2.37,2.37,0,0,0,2.11-1.29l3.46-7.75a1.47,1.47,0,0,0-.77-1.95l-3-1.27a1.84,1.84,0,0,1-1-2,35.4,35.4,0,0,0,.64-3.7,4.62,4.62,0,0,1,1.23-2.51l5.07-4.65a3,3,0,0,0,.83-1.73l4.6-3.58Zm-23,35.71c-6.2,4.86-12.12,3.54-13.24-3s3.94-14.77,10.13-19.64,11.17-4.5,12.29,2S300.1,198.36,293.91,203.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,202l-5,4.6a2.87,2.87,0,0,0-.77,1.44l7.43,4.3v-.4a1.46,1.46,0,0,1,2,.46h0l7.17-4.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,188.06a29.74,29.74,0,0,1,1.84-2.54l-7.14-4.12a2.66,2.66,0,0,1-1,.22l-3.68-.18a2.27,2.27,0,0,0-1.52.55l11,6.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.89,171a1,1,0,0,0-1,.12l-5.06,3.33a1.47,1.47,0,0,1-2-.46,9.83,9.83,0,0,0-1-1.21,2.5,2.5,0,0,1-.59-2.41l.48-1.29,2.17-1.43a1,1,0,0,1,1.05-.1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.94,169.5c-.06-.06-.11-.14-.17-.21a2.49,2.49,0,0,1-.59-2.4l8-5.1-6-3.46h0a1.68,1.68,0,0,0-.39-.16l-3.82-.85a2.08,2.08,0,0,0-2.16,1l-3.58,6.83a3.06,3.06,0,0,1-.82.92l8.1,4.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,167.94l7.43,4.29,6.12-5.6a10.2,10.2,0,0,0,.25-1.37l-6-3.48h0A1,1,0,0,0,290,162l-5.71,4.49A3,3,0,0,0,283.39,167.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.32,177.28l-.95-5.52a.91.91,0,0,0-1.51-.66l-5.06,3.33a1.46,1.46,0,0,1-2-.46,9.65,9.65,0,0,0-1-1.2,2.54,2.54,0,0,1-.6-2.41l2.58-7a1.28,1.28,0,0,0-.94-1.74l-3.81-.85a2.07,2.07,0,0,0-2.16,1l-3.59,6.83a3.7,3.7,0,0,1-2.16,1.63,19.58,19.58,0,0,0-2.35.78,1.29,1.29,0,0,1-1.8-.83l-1.29-4.27a1,1,0,0,0-1.62-.51l-5.71,4.49a3.17,3.17,0,0,0-1.08,2.42l.34,5.44a4.35,4.35,0,0,1-.89,2.63c-.94,1.12-1.82,2.29-2.66,3.51a2.94,2.94,0,0,1-2.32,1.18l-3.67-.18A2.37,2.37,0,0,0,278,186.2L274.49,194a1.47,1.47,0,0,0,.77,2l3,1.27a1.84,1.84,0,0,1,1,2,35.4,35.4,0,0,0-.64,3.7,4.59,4.59,0,0,1-1.23,2.51l-5.07,4.65a3.07,3.07,0,0,0-.85,2.49l1,5.53a.91.91,0,0,0,1.51.65l5.06-3.33a1.47,1.47,0,0,1,2,.46,11.83,11.83,0,0,0,1,1.21,2.5,2.5,0,0,1,.59,2.41l-2.58,7a1.28,1.28,0,0,0,.94,1.74l3.82.85a2.08,2.08,0,0,0,2.16-1l3.58-6.83a3.75,3.75,0,0,1,2.17-1.63,18,18,0,0,0,2.35-.78,1.3,1.3,0,0,1,1.8.83l1.29,4.27a1,1,0,0,0,1.61.51l5.71-4.49a3.21,3.21,0,0,0,1.09-2.42l-.34-5.44a4.28,4.28,0,0,1,.89-2.63c.93-1.12,1.82-2.29,2.65-3.51a3,3,0,0,1,2.32-1.18l3.68.18a2.38,2.38,0,0,0,2.11-1.29l3.45-7.74a1.47,1.47,0,0,0-.77-2l-3-1.27a1.82,1.82,0,0,1-1-2,35.33,35.33,0,0,0,.63-3.7,4.64,4.64,0,0,1,1.24-2.5l5.06-4.66A3.07,3.07,0,0,0,324.32,177.28Zm-24.4,29.42c-6.19,4.87-12.12,3.54-13.24-3s3-15.73,9.18-20.6,12.12-3.54,13.24,3S306.11,201.83,299.92,206.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,114.07l-5.92-3.41h0a1,1,0,0,0-.92,0l-10.7,4.82a1.28,1.28,0,0,1-1.79-.83,24,24,0,0,0-2.38-5.3,3,3,0,0,1-.16-2.59l7.13-14.38a1.63,1.63,0,0,0-.64-2.1l-7.73-4.46a1.61,1.61,0,0,0-2.13.49L254.16,99.7a3,3,0,0,1-2.33,1.16,21.77,21.77,0,0,0-3.1.14V91.23l-5.94-3.43h0a1,1,0,0,0-1,.09l-12,6.94a3.27,3.27,0,0,0-1.44,2.25l-1.2,13.37a4.43,4.43,0,0,1-1.25,2.5,72.57,72.57,0,0,0-6.68,7.07,2.32,2.32,0,0,1-2.36.67l-7.72-2.7a1.88,1.88,0,0,0-2.16.81l-8.84,15.3a1.89,1.89,0,0,0,.39,2.28l6.19,5.34a2.29,2.29,0,0,1,.6,2.38,71,71,0,0,0-2.78,9.31,4.41,4.41,0,0,1-1.54,2.33l-11,7.73a3.25,3.25,0,0,0-1.23,2.37v13.88a1,1,0,0,0,.43.89h0l5.92,3.42,8.79-4.17a21,21,0,0,0,1.1,2,3,3,0,0,1,.16,2.59l-7.13,14.38a1.61,1.61,0,0,0,.63,2.09l7.74,4.47a1.61,1.61,0,0,0,2.13-.5l8.89-13.36a2.94,2.94,0,0,1,2.32-1.16,24.05,24.05,0,0,0,5.79-.58,1.26,1.26,0,0,1,1.6,1.13l1.18,11.67a1,1,0,0,0,.46.82h0l5.91,3.4,7.1-10.42a3.26,3.26,0,0,0,1.43-2.25l1.2-13.37a2.71,2.71,0,0,1,1.54-2,28.2,28.2,0,0,0,9.34-6.55,2.44,2.44,0,0,1,2.39-.64l4.74,1.67a1.88,1.88,0,0,0,2.17-.8l8.83-15.3a1.89,1.89,0,0,0-.38-2.28L269,151.39a2.47,2.47,0,0,1-.66-2.4,40.36,40.36,0,0,0,1.1-11.09,3.14,3.14,0,0,1,1.15-2.37l11-7.73a3.24,3.24,0,0,0,1.22-2.36l5.25-6.29Zm-52.49,55c-11.22,6.47-18.19,1.88-18.19-11.07s9.27-28.82,20.48-35.29,18-1.77,18,11.18S247,162.61,235.81,169.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.19,97.15l2.36-4.75a1.63,1.63,0,0,0-.64-2.1l-7.73-4.46a1.61,1.61,0,0,0-2.13.49L254.16,99.7a2.47,2.47,0,0,1-.59.57l9.95,5.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.86,154.84a3.88,3.88,0,0,1-.85.9l-11,7.73a3,3,0,0,0-.73.83l6.71,3.87,14.57-8.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,117.9a1.89,1.89,0,0,0-1.54.9l-8.84,15.3a1.81,1.81,0,0,0-.2,1.12l7.62,4.4,12.1-16.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,96.28l9.42,5.44,10.71-6.18V91.23l-5.94-3.43h0a1,1,0,0,0-1,.09l-12,6.94A3.21,3.21,0,0,0,228.6,96.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.72,128.85V115a.89.89,0,0,0-1.36-.89l-10.7,4.83a1.27,1.27,0,0,1-1.78-.83,24.5,24.5,0,0,0-2.39-5.3,3,3,0,0,1-.16-2.59l7.13-14.38a1.63,1.63,0,0,0-.63-2.1l-7.74-4.47a1.62,1.62,0,0,0-2.13.5l-8.89,13.37a2.93,2.93,0,0,1-2.33,1.15,24.51,24.51,0,0,0-5.78.59,1.27,1.27,0,0,1-1.61-1.13L249.18,92a.9.9,0,0,0-1.45-.74l-12,6.94a3.25,3.25,0,0,0-1.44,2.24l-1.2,13.38a4.46,4.46,0,0,1-1.25,2.5,72.57,72.57,0,0,0-6.68,7.07,2.3,2.3,0,0,1-2.36.66l-7.72-2.69a1.88,1.88,0,0,0-2.16.8l-8.84,15.31a1.89,1.89,0,0,0,.39,2.28l6.19,5.33a2.31,2.31,0,0,1,.6,2.39,71,71,0,0,0-2.78,9.31,4.41,4.41,0,0,1-1.54,2.33l-11,7.73a3.25,3.25,0,0,0-1.23,2.37v13.88a.9.9,0,0,0,1.37.88l10.7-4.82a1.27,1.27,0,0,1,1.78.82,23.9,23.9,0,0,0,2.39,5.31,3,3,0,0,1,.16,2.59L204,202.29a1.61,1.61,0,0,0,.63,2.09l7.74,4.47a1.61,1.61,0,0,0,2.13-.5L223.37,195a3,3,0,0,1,2.32-1.16,23.58,23.58,0,0,0,5.79-.59,1.28,1.28,0,0,1,1.61,1.13l1.17,11.68a.9.9,0,0,0,1.45.75l12-7a3.19,3.19,0,0,0,1.43-2.24l1.21-13.38a4.43,4.43,0,0,1,1.25-2.49,72.41,72.41,0,0,0,6.67-7.07,2.3,2.3,0,0,1,2.36-.67l7.72,2.69a1.88,1.88,0,0,0,2.17-.8l8.84-15.31a1.88,1.88,0,0,0-.39-2.27L272.8,153a2.29,2.29,0,0,1-.6-2.38,73.85,73.85,0,0,0,2.78-9.32,4.45,4.45,0,0,1,1.54-2.33l11-7.73A3.24,3.24,0,0,0,288.72,128.85Zm-47,43.65c-11.22,6.47-20.31,1.22-20.31-11.73s9.09-28.7,20.31-35.17S262,124.37,262,137.32,252.93,166,241.72,172.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,114.07h0a1,1,0,0,0-.95,0l-10.7,4.82a1.27,1.27,0,0,1-1.78-.82,23.08,23.08,0,0,0-1.53-3.76l8.1-3.65a1,1,0,0,1,.93,0h0Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.54,374.67v-1.14c-.45,1.34-2.53,7.08-5.69,10-2.51,2.29-5.93,4.94-6.81,7.49s4.77,3.54,7.11,3.13c2.73-.48,6.25-2,8.17-4.39,1.35-1.65,2.21-3.62,3.17-4.92s3.19-2.76,3.71-4.27c.29-.83-.05-2.64-.46-4.18s-.76-3-1.25-2.82v.87a6.26,6.26,0,0,1-4,1.34C375.35,375.79,372.53,375.56,372.54,374.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,385.51c.78-.7,1.56-1.38,2.27-2,2.21-2,3.89-5.42,4.85-7.75a11,11,0,0,0,.84-4.19V367h7.95v7.38h0v.2l0,0c-.38,1.65-4,6.05-6.1,8.92-1.4,1.92-4,4.37-7.2,4.79C364.16,388.72,362.63,387.78,364.58,385.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,366.83v-1.14c-.45,1.33-2.53,7.08-5.69,10-2.51,2.29-5.93,4.93-6.8,7.48s4.76,3.55,7.11,3.14c2.72-.49,6.25-2,8.16-4.39,1.35-1.66,2.21-3.62,3.18-4.93s3.18-2.75,3.7-4.26c.29-.83-.05-2.65-.45-4.18s-.77-2.95-1.25-2.82v.87a6.32,6.32,0,0,1-4,1.34C344.31,367.94,341.49,367.71,341.5,366.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,377.66c.78-.69,1.56-1.37,2.27-2,2.21-2,3.89-5.42,4.85-7.75a10.77,10.77,0,0,0,.84-4.19v-4.53h8v7.38h0v.2l0,0c-.39,1.65-4,6.05-6.11,8.92-1.39,1.92-4,4.36-7.19,4.79S331.59,379.93,333.54,377.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,251c6.17,13.48-.22,60.94-.22,60.94.18,2.19,2.68,6.49,3.62,16.11,1.1,11.37-1.73,39.92-1.73,39.92a8.61,8.61,0,0,1-8,.32s-7.59-43-9-54.3c-1.25-9.87-3.64-31.56-3.64-31.56l-6.78,31.51a58.76,58.76,0,0,1,2.15,9.73c.64,6.65-5.8,37.61-5.8,37.61s-2.75,1-8,.24c0,0-2.28-41.08-2.88-49.09-1-13.46,2.56-55.43,5-63.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89,282.43l-2-12.52s-8.47-1.75-12.31-5.36a21.9,21.9,0,0,0,10,6.65l2.24,9.64L353.91,310Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.85,242.51c4.67-15.54,10.62-38.68,8.38-38.68s-5.7-.21-8.23,2.33c-5,5-5.89,14.28-6.94,19.58s-1.79,9.47-3.46,17.32c-1.26,6-2.81,13.17-5.06,17.77a3.69,3.69,0,0,1-2,1.78c-2.26.92-3.3,2.09-5.11,3.43-1.42,1-2.5,1.18-2.41,1.61a2,2,0,0,0,2.37,1.33,13.75,13.75,0,0,0,3.16-1.06,18.61,18.61,0,0,1-3.83,4.57c-3.46,3-4,5.13,1.79,6.18,3.61.66,6.88-1.07,11-8.56a66.19,66.19,0,0,0,4.09-8.49C343.36,254,345.44,247.21,346.85,242.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,204.2h0c7.91.54,8.46,4.36,10.44,8.54a13.51,13.51,0,0,1,.38,10.19l-5.52,15.94s2.59,6.24,5.58,12.13c-13.83,7.72-31.1,3.67-35.26-2-.17-1.19.89-10.53,1.55-16.63-2.43-6.12-3.08-10-2.05-14,1.91-7.5,9.32-14.8,12.59-14.53Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43,197.64h3.07a16.17,16.17,0,0,0,16.16-16.16h0a16.26,16.26,0,0,0-16.25-16.26h-2.9a16.26,16.26,0,0,0-16.25,16.26h0A16.17,16.17,0,0,0,360.43,197.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.32,206.16h0a9.55,9.55,0,0,1-9.55-9.55V176.16h0a9.55,9.55,0,0,1,9.55,9.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.52,172.53l-2.4,3.85a2.2,2.2,0,0,0,3.12-.64A2.38,2.38,0,0,0,380.52,172.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,172.38c-1.87,1.11-4.18,5.81-4,15.67.2,8.35,2.9,10.41,4.26,11s4,.23,6.54-.19v5s-3.53,4.09-3.31,6.39,5.09,2.85,8.39.6a21.32,21.32,0,0,0,5.41-5.67V193.08a3.2,3.2,0,0,0,4.54.43c2.81-1.87,2.92-6.49,1.28-8.15s-5.16-1.14-5.82,1.16c0,0-4.07.14-9.48-2.83A15.23,15.23,0,0,1,350.08,172.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.39,186a1.07,1.07,0,0,0,1,1.14,1.09,1.09,0,0,0,1.11-1,1.05,1.05,0,1,0-2.1-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.17,193l-2.44.78a1.25,1.25,0,0,0,1.59.87A1.34,1.34,0,0,0,355.17,193Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.77,182.72l2.13-1.47a1.24,1.24,0,0,0-1.77-.36A1.35,1.35,0,0,0,347.77,182.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,185.19a1.05,1.05,0,1,0,2.1.1,1.06,1.06,0,0,0-1-1.14A1.08,1.08,0,0,0,348.26,185.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.39 184.59 353.23 190.91 349.9 189.88 353.39 184.59",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,198.87c2.68-.36,8.21-1.94,9.07-4.13a5.57,5.57,0,0,1-1.94,2.79c-1.65,1.42-7.13,3-7.13,3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.49,252.5a8.35,8.35,0,0,0,6.23-10.18c-.05-.17-.1-.32-.14-.44a2.7,2.7,0,0,0-2.8-1.85h0a8.09,8.09,0,0,0,3.45-5.16l1.68-8.43s-3.12-9.9-2.8-13.3l7.94.46,1,.72a13.86,13.86,0,0,1-.22,8.61l-5.52,15.94s2.59,6.24,5.58,12.13a35.75,35.75,0,0,1-29.55,2A40.23,40.23,0,0,0,364.49,252.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,244.78c-2.92.78-11.81,1.83-12.47-4.41a109.55,109.55,0,0,1,0-14.93,36.09,36.09,0,0,1,7.61-20.26l.36-.44s-1.29-1.05-4-.56a30.31,30.31,0,0,0-7.82,14c-4-.58-9-1-12.34-1.26a23.19,23.19,0,0,1,9.67-13,5.12,5.12,0,0,0-3.53-.06,22.06,22.06,0,0,0-9.76,12.82c-3.18,8.81-3.06,41.64-3,53.3l5.49-8.74h35C380.69,248.66,375.92,244.78,375.92,244.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,236.25s-3.73-8-8.92-19.79c-3.75-8.54-4.58-10.47-10.55-11.39l-2.1-.33c-2.83,9.29-.88,13.49,2.84,19.85l7.36,14.26C384.58,238.27,393.1,237.14,393,236.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,238.85c2.18,4.39,4,7.11,6.7,7.82s24.55.46,24.55.46v-8.28l-20.84-3.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.43,329.76H391v67.09c-.16,2.66,1.5,5.35,5,7.38,6.73,3.89,17.64,3.89,24.37,0,3.37-1.94,5.05-4.49,5.05-7h0Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,323.66h0c-3.81-2.49-1.44-8.55-1.44-8.55H396s2.3,6-1.44,8.55h0c-5.26,3.91-4.79,9.54,1.42,13.13,6.73,3.89,17.64,3.89,24.37,0C426.59,333.2,427.06,327.57,421.81,323.66Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,323.66h0c-3.81-2.49-1.44-8.55-1.44-8.55H396s2.3,6-1.44,8.55h0c-5.26,3.91-4.79,9.54,1.42,13.13,6.73,3.89,17.64,3.89,24.37,0C426.59,333.2,427.06,327.57,421.81,323.66Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,318.1a12.7,12.7,0,0,1,.67-3H396a12.54,12.54,0,0,1,.65,3C403.2,321.5,413.16,321.5,419.71,318.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.43,303.39h-2a12.85,12.85,0,0,0-3-2.35c-6.73-3.88-17.64-3.88-24.37,0a12.85,12.85,0,0,0-3,2.35h-2v4.69h0c0,2.55,1.68,5.09,5.05,7,6.73,3.89,17.64,3.89,24.37,0,3.37-1.94,5.05-4.48,5.05-7h0Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,310.42c6.73,3.89,17.64,3.89,24.37,0s6.73-10.18,0-14.07-17.64-3.88-24.37,0S389.28,306.54,396,310.42Z",
    style: {
      fill: "#88BACC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,310.42c6.73,3.89,17.64,3.89,24.37,0s6.73-10.18,0-14.07-17.64-3.88-24.37,0S389.28,306.54,396,310.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.21,399.83h0a3.36,3.36,0,0,1-3.36-3.36V348.54a3.36,3.36,0,0,1,3.36-3.36h0a3.36,3.36,0,0,1,3.35,3.36v47.93A3.36,3.36,0,0,1,408.21,399.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.68,397.8h0c-1.61.59-2.91-.24-2.91-1.85V347.13a4.6,4.6,0,0,1,2.91-4h0c1.61-.58,2.91.24,2.91,1.85v48.83A4.59,4.59,0,0,1,419.68,397.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73,397.8h0c1.61.59,2.91-.24,2.91-1.85V347.13a4.6,4.6,0,0,0-2.91-4h0c-1.61-.58-2.91.24-2.91,1.85v48.83A4.59,4.59,0,0,0,396.73,397.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.91,182.71l-7-4.06-4.44,20.89s4.44,7.25,4.44,11.94V300.6l4.65,5.44,2.39-1.38V215.55c0-4.69,4.43-6.82,4.43-6.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.52,184.09l-7-4.07-4.44,20.89s4.44,7.26,4.44,12V302l7,4.07V216.92c0-4.69,4.44-6.82,4.44-6.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.49 180.02 405.87 178.65 412.91 182.71 410.52 184.09 403.49 180.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.91 182.71 410.52 184.09 414.96 210.1 417.34 208.73 412.91 182.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.91,232.28c.36-1.57,2.84-2.45,2.59.17s1,4.45,1.37,5.67c.75,2.57.58,7.42-.43,8.38a5.44,5.44,0,0,1-4.23,1.91,8.7,8.7,0,0,1-5.27-2.14c-1.62-1.26-3.35-8.5.41-7.48,5.59,1.53,5.56-2.49,5.56-2.49Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.06,256c3.93.79,6.26,3.68,11,11S252.14,287,252.14,287l18.38,7-.79,8.27s-20.05-3.56-22.8-5.6-13.36-17.42-13.36-17.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,254.51c4.08.72,8.12,1.71,10.63,5.6s11.65,18.75,11.65,18.75-3.33,7.82-9.41,9l-8.74-12.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,254.84c-1.4.34-2.81.43-4.05.68-6.07,1.22-7.19,4.37-7.34,11.71-.24,12.27,0,40.67,0,40.67,5.41,3.93,25.39,6.34,36.77-2,0,0-.58-32.67-.58-38.46s-3.21-12.74-12.09-13.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.99,
    y: 408.01,
    width: 7.85,
    height: 13.44,
    transform: "translate(403.82 829.46) rotate(180)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.1 411.27 237.94 411.54 238.34 397.32 230.1 397.05 230.1 411.27",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,305.93h0L235.89,274l-24.7,4a107.4,107.4,0,0,1-.88,15.1c-.46,3.94-4.24,9.31-10.94,11.08a149.51,149.51,0,0,0-.06,15.49c.12,3.72-1.63,44.85-1.63,44.85-.18,2.16-2.26,6-2.42,13.76-.23,11.27,2.39,36.43,2.39,36.43a10.31,10.31,0,0,0,8.74.17s5.28-36.16,6.69-47.31c1.22-9.73,6.35-37.11,6.35-37.11l6,32.91a44.43,44.43,0,0,0-1,12.48c.36,5.15,5.14,31,5.14,31a10.75,10.75,0,0,0,9.07.69s.46-40.56.56-45.3C239.33,356.87,237.3,305.93,237.3,305.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,274c-.26-6.31-1.14-12.14-6.58-17.6a7.89,7.89,0,0,0-5.59-2.28h-1.17s5.46,4.33,7.6,10.62A42.26,42.26,0,0,1,231.88,277Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,417.57v-1.12c.42,0,.68.41.84,1.42.12.72.22,1.27.46,2.22a25.54,25.54,0,0,0,1.37,4c1.11,2.74,2,3.75,4.58,6.95a28.06,28.06,0,0,1,2.44,2.81c.48.84.64,3.19-.16,3.73-3,2-7.47,2-10.65,1.1a6.44,6.44,0,0,1-4.63-5.19c-.11-.73-.07-1.47-.15-2.2a10.44,10.44,0,0,0-2-4.56,14.29,14.29,0,0,1-1.51-2.48c-.66-1.61-.13-3.43.29-5,.37-1.39.76-2.92,1.24-2.79v.86a6.15,6.15,0,0,0,3.92,1.32C203.06,418.68,205.85,418.45,205.84,417.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,409.12c.41,0,.74.59,1.64,1.56a17,17,0,0,0,4.61,3.33c2.94,1.47,8.66,3.73,11.25,4.9,1.61.72,1.54,2.68-.13,3.79s-5.71,1.91-10.55.83c-2.64-.59-6.07-3-8.25-2.9s-6.24.1-7.84-1-1-3.46-.51-5.49c.5-2.22,1.11-5.67,1.85-5.52v.76c.94,1.43,5.81,2,7.89,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,330.48a29,29,0,0,0,10.93-6.26s-2.11,3.94-8.38,7.62l3,29.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.72,
    cy: 228.75,
    r: 10.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,236.42s1.75,8.21,2.45,9.56a3.7,3.7,0,0,0,2.15,1.73l-.13-5.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,224.65a4.06,4.06,0,0,0-3.35,1.18c-1.44,1.47-.64,6.08,1.16,10.59l3.29.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,236.8c-.66.39-1.6-.88-2.42-1.73s-3.47-2-4.8.78,1.17,6.61,3.27,7.27c3.6,1.13,4.14-1.18,4.14-1.18l.27,13.41h0c4.49,5.75,16.93,5.26,11.75-.75v-4a22.44,22.44,0,0,0,4.86.25c2.65-.41,4.32-2.5,5.12-5.37,1.3-4.61,1.79-8.34.69-17.41-1.2-9.94-12.76-10-19-6.11S210.35,236.8,210.35,236.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.18,280c.18-8.16-1.68-20.26-4.42-24.44a7.9,7.9,0,0,1,4.05-.68s5.14,8,4.92,25.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,237.91c-.33,0-1.6-2.09-2.42-2.84-1.14-1,.33-10.42.33-10.42a4.55,4.55,0,0,1,.79-5.07c1.56-1.71,3.73-3.81,10.81-3,5,.59,10.54,2.17,15,0a7.54,7.54,0,0,1-2.63,8s-1.61,1-5.83,1.55a62.3,62.3,0,0,1-11.71-.22c-1.22-.17-1.48,1-2.14,4.26C212,233.06,211.46,237.89,210.35,237.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27,225.38l-4-2.14a2.2,2.2,0,0,1,3-1A2.39,2.39,0,0,1,208.27,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55,250.64s-5.93-1.19-8-2.29a6.89,6.89,0,0,1-2.86-2.83,9.32,9.32,0,0,0,1.63,3.34c1.51,1.93,9.23,3.36,9.23,3.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.32,236.07a1.19,1.19,0,1,1-1.18-1.24A1.21,1.21,0,0,1,222.32,236.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.07,231.59l-2.54,1.4a1.51,1.51,0,0,1,.59-2A1.42,1.42,0,0,1,221.07,231.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,243.52l2.71,1a1.42,1.42,0,0,1-1.84.9A1.51,1.51,0,0,1,222,243.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.91,232.58l-2.32-1.79a1.4,1.4,0,0,1,2-.31A1.55,1.55,0,0,1,232.91,232.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,235.73a1.19,1.19,0,1,1-1.18-1.24A1.22,1.22,0,0,1,232.19,235.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.84 234.83 226.22 241.97 229.95 240.7 225.84 234.83",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,248.09c0-2.2,1.84-5.27,1.28-6.9l-4.06-2.35-8.14,20.45-8.3,4.72-4.1-6,12.27-18.31-4.06-2.34c-.51.24-1,.5-1.56.8-9.27,5.27-16.84,18.25-16.91,29,0,5.42,1.85,9.22,4.91,11h0l4,2.33.47-1.22h.3v95.15c-5.7,6.35-9.67,15.27-9.72,23,0,4,1,7.16,2.79,9.24l4.06,2.35,4.07-22.8,8.3-4.72,4.1,6L264,408.18l4.06,2.34s14.34-21.4,14.41-32.14a15.28,15.28,0,0,0-1.75-7.73l1-.85-4-2.33h0a8.78,8.78,0,0,0-5-1.21V271.12C278.44,264.77,282.41,255.86,282.46,248.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.6 374.43 262.66 376.78 262.66 281.63 258.6 279.28 258.6 374.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,368.62V273.47c5.7-6.35,9.67-15.27,9.72-23,0-4-1-7.16-2.78-9.24l-8.14,20.45-8.3,4.72-4.1-6,8.21-20.66q-.77.36-1.56.81c-9.27,5.27-16.84,18.25-16.91,29-.05,7.88,3.94,12.34,9.72,12.11v95.15c-5.7,6.34-9.67,15.26-9.72,23,0,4,1,7.16,2.79,9.25l8.13-20.46,8.3-4.71,4.1,6-8.21,20.65c.52-.24,1-.5,1.56-.8,9.27-5.27,16.84-18.25,16.91-29C286.57,372.85,282.58,368.39,276.8,368.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.39 384.89 272.16 383.89 276.26 389.87 268.05 410.52 263.99 408.18 272.2 387.52 270.39 384.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,290.4c0,1.53-2.32,3.23-4,4.3s-3.86,2.56-3,5.65a4.41,4.41,0,0,0,5.82,3.06,6.35,6.35,0,0,0,3.77-5.08c.42-2.85,1.38-9.67-2.52-10.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63,298.58c6.76-30.35,11-37,20.4-40.47l-1.28,18.24S193.93,296,192.6,303c-1.17,6.11-2.48,13.79-2.27,19a3.74,3.74,0,0,0,1.07,2.46c1.73,1.8,2.22,3.31,3.36,5.31.88,1.57,1.83,2.14,1.57,2.5a2,2,0,0,1-2.76.26,14,14,0,0,1-2.51-2.3,19.13,19.13,0,0,0,1.69,5.85c2,4.23,1.57,6.42-4.23,5-3.64-.88-6-3.84-6.69-12.51a66.94,66.94,0,0,1-.29-9.61C182.14,310.71,182.54,303.46,183.63,298.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85,256a13.56,13.56,0,0,0-6.79,2.09c-2.36,1.59-6.29,8-8.78,15.93s-3.8,12.33-3.8,12.33,4.08,6.21,12.88,3.76c0,0,4.95-12.4,4.67-11.61C203,278.52,209.59,266.29,204.85,256Z",
    style: {
      fill: "#e6e6e6"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Maintenance.0f79d10b.svg";
export { ForwardRef as ReactComponent };